goog.provide("shadow.js.shim.module$react_markdown$default");
shadow.js.shim.module$react_markdown$default = shadow.js.require(409, {}).default;
